
    document.addEventListener('DOMContentLoaded', function () {
      // Counter Animation Function
      function animateCounter(element) {
        const target = parseFloat(element.dataset.target);
        const suffix = element.dataset.suffix || '';
        const duration = parseInt(element.dataset.duration) || 2000;
        const delay = parseInt(element.dataset.delay) || 200;

        // Don't animate if target is not a valid number
        if (isNaN(target)) {
          element.textContent = element.dataset.target + suffix;
          return;
        }

        // Add delay before starting animation
        setTimeout(() => {
          const startTime = performance.now();
          const startValue = 0;

          function updateCounter(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);

            // Use easeOutCubic for smooth animation
            const easeProgress = 1 - Math.pow(1 - progress, 3);
            const currentValue = startValue + (target - startValue) * easeProgress;

            // Format the number based on target type
            let displayValue;
            if (target % 1 === 0) {
              // Integer
              displayValue = Math.floor(currentValue);
            } else {
              // Decimal - preserve original decimal places
              const decimalPlaces = target.toString().split('.')[1]?.length || 1;
              displayValue = currentValue.toFixed(decimalPlaces);
            }

            element.textContent = displayValue + suffix;

            if (progress < 1) {
              requestAnimationFrame(updateCounter);
            } else {
              // Ensure final value is exact
              element.textContent = target + suffix;
            }
          }

          requestAnimationFrame(updateCounter);
        }, delay);
      }

      // Intersection Observer for triggering animations when elements come into view
      const observerOptions = {
        threshold: 0.3,
        rootMargin: '0px 0px -50px 0px',
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !entry.target.classList.contains('animated')) {
            entry.target.classList.add('animated');
            animateCounter(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      // Observe all counter elements
      const counters = document.querySelectorAll('.section-template--30445709951324__statistics_column_wxQ8aH .counter-animate');
      counters.forEach((counter) => {
        observer.observe(counter);
      });
    });
  